const KEY = 'pa-listing-nav'
// Stale orderings are worse than no arrows: after a long pause the feed the
// user remembers no longer exists.
const TTL_MS = 6 * 60 * 60 * 1000

// Navigation context for the listing page: the ordered id list of the feed
// the user came from (search grid, cabinet strips). Written on card click,
// read by the prev/next arrows and the mobile swipe on /announcement/:id.
export const saveListingNavContext = (ids: string[]): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ids, ts: Date.now() }))
  } catch {
    // Private mode / quota — the arrows simply will not appear.
  }
}

export const getListingNavContext = (): string[] | null => {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as { ids?: unknown; ts?: number }
    if (!Array.isArray(parsed.ids) || parsed.ids.some((id) => typeof id !== 'string')) return null
    if (!parsed.ts || Date.now() - parsed.ts > TTL_MS) return null
    return parsed.ids as string[]
  } catch {
    return null
  }
}
